import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const getUrl = (url, moduleName = null) => {
  const urlWithModule = url.replace(':moduleName', moduleName ? moduleName : '')
  return urlWithModule
}

const addModule = (moduleName, enabledModule) => axios({
  url: `${getUrl(config.endpoints.modules.add, moduleName)}`,
  params: {
    enabledModule
  },
  method: 'post',
  headers: getHeaders(true)
})

const removeModule = (moduleName, disabledModule) => axios({
  url: `${getUrl(config.endpoints.modules.remove, moduleName)}`,
  params: {
    disabledModule
  },
  method: 'post',
  headers: getHeaders(true)
})

const validateGrafanaAccess = (data) => axios({
  url: config.endpoints.modules.validateGrafanaAccess,
  method: 'post',
  data,
  headers: getHeaders(true)
})

export default {
  addModule,
  removeModule,
  validateGrafanaAccess
}